/**
 * @generated SignedSource<<04ed40e1022b37738b431218c220a201>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MarkChatThreadReadInput = {
  chatThreadId?: string | null | undefined;
  chatThreadRawId?: number | null | undefined;
  clientMutationId?: string | null | undefined;
};
export type ChatThreadMessages_MarkReadMutation$variables = {
  input: MarkChatThreadReadInput;
};
export type ChatThreadMessages_MarkReadMutation$data = {
  readonly markChatThreadRead: {
    readonly chatThread: {
      readonly " $fragmentSpreads": FragmentRefs<"ChatDialogContent_Thread">;
    } | null | undefined;
    readonly currentUser: {
      readonly " $fragmentSpreads": FragmentRefs<"ChatBubble_User">;
    } | null | undefined;
  } | null | undefined;
};
export type ChatThreadMessages_MarkReadMutation = {
  response: ChatThreadMessages_MarkReadMutation$data;
  variables: ChatThreadMessages_MarkReadMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "avatarUrl",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = [
  (v2/*: any*/)
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v7 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ChatThreadMessages_MarkReadMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MarkChatThreadReadPayload",
        "kind": "LinkedField",
        "name": "markChatThreadRead",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ChatThread",
            "kind": "LinkedField",
            "name": "chatThread",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ChatDialogContent_Thread"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "currentUser",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ChatBubble_User"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ChatThreadMessages_MarkReadMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MarkChatThreadReadPayload",
        "kind": "LinkedField",
        "name": "markChatThreadRead",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ChatThread",
            "kind": "LinkedField",
            "name": "chatThread",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "purpose",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "defaultTitle",
                "storageKey": null
              },
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "recipient",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isRecipient"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "firstName",
                        "storageKey": null
                      },
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Profile",
                        "kind": "LinkedField",
                        "name": "profile",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "slug",
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "timezoneName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "self",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lastSeenAt",
                        "storageKey": null
                      }
                    ],
                    "type": "User",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v2/*: any*/)
                    ],
                    "type": "ChatBot",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v5/*: any*/),
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "meetingRoom",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "enableMeetingRoom",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "threadType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "users",
                "plural": true,
                "selections": (v5/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "currentUser",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Configuration",
                "kind": "LinkedField",
                "name": "configuration",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "profileFeedbackParticipants",
                    "plural": true,
                    "selections": (v5/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": "unreads",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "filters",
                    "value": {
                      "listableThread": true,
                      "unread": true
                    }
                  }
                ],
                "concreteType": "ChatMessageConnection",
                "kind": "LinkedField",
                "name": "allChatMessages",
                "plural": false,
                "selections": [
                  (v6/*: any*/)
                ],
                "storageKey": "allChatMessages(filters:{\"listableThread\":true,\"unread\":true})"
              },
              {
                "alias": null,
                "args": (v7/*: any*/),
                "concreteType": "ChatThreadConnection",
                "kind": "LinkedField",
                "name": "chatThreads",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ChatThread",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": (v5/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": "chatThreads(first:1)"
              },
              {
                "alias": null,
                "args": (v7/*: any*/),
                "concreteType": "UserConnection",
                "kind": "LinkedField",
                "name": "contacts",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": (v5/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": "contacts(first:1)"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "guest",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3076a8b4726ee462a6ba4b3db33099a9",
    "id": null,
    "metadata": {},
    "name": "ChatThreadMessages_MarkReadMutation",
    "operationKind": "mutation",
    "text": "mutation ChatThreadMessages_MarkReadMutation(\n  $input: MarkChatThreadReadInput!\n) {\n  markChatThreadRead(input: $input) {\n    chatThread {\n      ...ChatDialogContent_Thread\n      id\n    }\n    currentUser {\n      ...ChatBubble_User\n      id\n    }\n  }\n}\n\nfragment ChatBubble_User on User {\n  id\n  configuration {\n    profileFeedbackParticipants {\n      id\n    }\n  }\n  unreads: allChatMessages(filters: {unread: true, listableThread: true}) {\n    totalCount\n  }\n  chatThreads(first: 1) {\n    totalCount\n    nodes {\n      id\n    }\n  }\n  contacts(first: 1) {\n    totalCount\n    nodes {\n      id\n    }\n  }\n  ...user_useIsGuest\n}\n\nfragment ChatDialogContent_Recipient on Recipient {\n  __isRecipient: __typename\n  ... on User {\n    id\n  }\n  ... on ChatBot {\n    id\n  }\n  ...ChatThreadTitle_Recipient\n  ...ChatThreadActions_Recipient\n}\n\nfragment ChatDialogContent_Thread on ChatThread {\n  id\n  purpose\n  ...ChatThreadTitle_Thread\n  ...ChatThreadActions_Thread\n  recipient {\n    __typename\n    ...ChatDialogContent_Recipient\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment ChatThreadActions_Recipient on Recipient {\n  __isRecipient: __typename\n  ... on User {\n    id\n  }\n  ... on ChatBot {\n    id\n  }\n  ...ChatThreadEditDialog_Recipient\n}\n\nfragment ChatThreadActions_Thread on ChatThread {\n  id\n  threadType\n  purpose\n  ...ChatThreadEditDialog_Thread\n  recipient {\n    __typename\n    ...ChatThreadActions_Recipient\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment ChatThreadEditDialog_Recipient on Recipient {\n  __isRecipient: __typename\n  ... on User {\n    id\n    name\n  }\n  ... on ChatBot {\n    id\n    name\n  }\n}\n\nfragment ChatThreadEditDialog_Thread on ChatThread {\n  id\n  title\n  avatarUrl\n  purpose\n  recipient {\n    __typename\n    ...ChatThreadEditDialog_Recipient\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  users {\n    id\n  }\n}\n\nfragment ChatThreadSettingsButton_Thread on ChatThread {\n  id\n  enableMeetingRoom\n}\n\nfragment ChatThreadSubheader_Recipient on Recipient {\n  __isRecipient: __typename\n  __typename\n  ... on User {\n    id\n    timezoneName\n  }\n  ... on ChatBot {\n    id\n  }\n  ...chat_useOnlineStatus\n}\n\nfragment ChatThreadTitle_Recipient on Recipient {\n  __isRecipient: __typename\n  ... on User {\n    name\n    firstName\n    avatarUrl\n    profile {\n      slug\n      id\n    }\n  }\n  ... on ChatBot {\n    avatarUrl\n    name\n  }\n  ...RecipientAvatar_Recipient\n  ...ChatThreadSubheader_Recipient\n}\n\nfragment ChatThreadTitle_Thread on ChatThread {\n  title\n  defaultTitle\n  avatarUrl\n  recipient {\n    __typename\n    ...ChatThreadTitle_Recipient\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  ...JoinVideoCallButton_Thread\n  ...ChatThreadSettingsButton_Thread\n}\n\nfragment JoinVideoCallButton_Thread on ChatThread {\n  meetingRoom\n  enableMeetingRoom\n}\n\nfragment RecipientAvatar_Recipient on Recipient {\n  __isRecipient: __typename\n  __typename\n  ... on User {\n    ...UserAvatarContainer_User\n  }\n  ... on ChatBot {\n    name\n    avatarUrl\n  }\n}\n\nfragment UserAvatarContainer_User on User {\n  id\n}\n\nfragment chat_useOnlineStatus on Recipient {\n  __isRecipient: __typename\n  __typename\n  ... on User {\n    self\n    lastSeenAt\n  }\n  ... on ChatBot {\n    __typename\n  }\n}\n\nfragment user_isGuest on User {\n  guest\n  status\n}\n\nfragment user_useIsGuest on User {\n  ...user_isGuest\n}\n"
  }
};
})();

(node as any).hash = "0dcd0841e88e20ffce12eccd00406e29";

export default node;
